"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_REGEXP = exports.EMAIL_REGEXP = exports.DATE_REGEXP = exports.ALPHANUMERIC_REGEXP = void 0;
const ALPHANUMERIC_REGEXP = /^(\d|\w)+$/i;
exports.ALPHANUMERIC_REGEXP = ALPHANUMERIC_REGEXP;
const DATE_REGEXP = /^\d{4}-\d{2}-\d{2}$/i;
exports.DATE_REGEXP = DATE_REGEXP;
const EMAIL_REGEXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
exports.EMAIL_REGEXP = EMAIL_REGEXP;
const NUMBER_REGEXP = /^\d+$/;
exports.NUMBER_REGEXP = NUMBER_REGEXP;
//# sourceMappingURL=regex.js.map